import * as React from 'react';
import * as NotificationSystem from 'react-notification-system';
var _NotificationSystem = React.createRef();
function NotificationWrapper() {
    return React.createElement(NotificationSystem, { ref: _NotificationSystem });
}
export default NotificationWrapper;
export var addNotification = function (notification) {
    return _NotificationSystem.current.addNotification(notification);
};



//////////////////
// WEBPACK FOOTER
// ./src/NotificationWrapper.tsx
// module id = 201
// module chunks = 81